import { render, staticRenderFns } from "./NovoEventoView.vue?vue&type=template&id=fa20c604&scoped=true"
import script from "./NovoEventoView.vue?vue&type=script&lang=js"
export * from "./NovoEventoView.vue?vue&type=script&lang=js"
import style0 from "./NovoEventoView.vue?vue&type=style&index=0&id=fa20c604&prod&lang=scss&scoped=true"
import style1 from "./NovoEventoView.vue?vue&type=style&index=1&id=fa20c604&prod&lang=scss"
import style2 from "./../../../../assets/css/listCard.css?vue&type=style&index=2&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa20c604",
  null
  
)

export default component.exports